import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StackDirectives } from '../../directives/stack-directives';

@Component({
  selector: 'app-error-page',
  imports: [StackDirectives],
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorPageComponent {
  errorCode: string = '404';
  errorMessage: string = '';
  errorDetails: string = '';

  constructor(private route: ActivatedRoute) {
    localStorage.clear(); // Limpiar localStorage al iniciar el componente de error
    this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      if (code) {
        this.errorCode = code;
      }
      this.setErrorMessages(this.errorCode);
      return;
    });
  }

  private setErrorMessages(code: string): void {
    switch (code) {
      case '0':
        this.errorMessage = '¡Ups! Parece que no tienes conexión';
        this.errorDetails =
          'No pudimos conectarnos al servidor. Verifica tu conexión a internet e inténtalo de nuevo. Si el problema persiste, contacta a soporte técnico.';
        break;
      case '401':
        this.errorMessage = 'Tu sesión ha finalizado';
        this.errorDetails = 'Por seguridad, tu sesión ha expirado. Por favor, vuelve a iniciar sesión.';
        break;
      case '403':
        this.errorMessage = 'No tienes acceso';
        this.errorDetails =
          'Esta sección no está disponible para tu usuario. Si crees que deberías tener acceso, comunícate con tu administrador.';
        break;
      case '404':
        this.errorMessage = '¡Vaya! No encontramos esta página';
        this.errorDetails = 'La dirección que ingresaste no existe o ha sido movida. Verifica la URL o vuelve al inicio.';
        break;
      case '500':
        this.errorMessage = 'Algo salió mal...';
        this.errorDetails =
          'Estamos teniendo un problema técnico. Ya estamos trabajando para solucionarlo. Intenta de nuevo en unos minutos.';
        break;
      //No HTTP
      case 'user_config':
        this.errorMessage = 'Hay algo mal con tu configuración';
        this.errorDetails =
          'Parece que tu cuenta no está configurada correctamente. Por favor, contacta a soporte técnico para asistencia.';
        break;
      default:
        this.errorMessage = 'Ocurrió un error inesperado';
        this.errorDetails = 'No pudimos procesar tu solicitud. Intenta más tarde o contacta a soporte si el problema persiste.';
        break;
    }
  }

  toLogin(): void {
    window.location.href = '/login'; // Redirigir al usuario a la página de inicio de sesión
  }
}
